import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Divider } from 'sdk'
import { Content } from 'sdk/components'
import { SDKDownloadBottomHero } from 'sdk/sections/sdk-download-bottom-hero/SDKDownloadBottomHero'

import { Hero } from './sections/hero/Hero'
import CTA from './sections/CTA/CTA'
import FeaturesSection from './sections/features/FeaturesSection'
import ShowcaseSection from './sections/showcase/ShowcaseSection'
import CyberBuckSection from './sections/cyber-buck/CyberBuckSection'
import { Solutions } from './sections/solutions/Solutions'
import { OnePlatform } from './sections/one-platform/OnePlatform'
import { PerformanceSpecs } from './sections/performance-specs/PerformanceSpecs'

import type { SoundscapePageLoaderData } from './interfaces'

export const SoundscapePage: React.FC = () => {
  const { cmsContent } = useLoaderData() as SoundscapePageLoaderData

  if (!cmsContent) {
    throw new Error('Soundscape CMS content missing')
  }

  return (
    <>
      <Hero content={cmsContent.hero} />
      <Content gap={150}>
        <CTA content={cmsContent.cta} />
        <FeaturesSection content={cmsContent.features} />
        <ShowcaseSection content={cmsContent.showcase} />
        <Divider />
        <CyberBuckSection content={cmsContent.cyberBuck} />
        <Solutions content={cmsContent.solutions} />
        <Divider />
        <OnePlatform content={cmsContent.onePlatform} />
        <PerformanceSpecs content={cmsContent.performanceSpecs} />
      </Content>
      <SDKDownloadBottomHero content={cmsContent.bottomHero} />
    </>
  )
}
